/**
 * A Variable appears to be a value that does not use a slider to set, said value. But really, who knows ¯\_(ツ)_/¯
 */
 import React, { Component } from 'react';
 import { connect } from 'react-redux';
 import ReactTable from 'react-table-v6';
 import './baseVariablesStyle.scss';
 import 'react-table-v6/react-table.css';
 import PropTypes from 'prop-types';
 import {
     inputVariablesAction,
     isParametersOrVariablesUpdatedAction,
 } from '../../../../../stores/actions/modelInputReader';
 import { Config } from '../../../../../shared/config';
 import { ModelHelper } from '../../../modelFunctions';
 import * as R from 'ramda';
 
 import modelInputService from '../modelInputService';
 
 class BaseVariables extends Component {
     constructor(props) {
         super(props);
         let session = localStorage.getItem('FOM_user');
         this.state = {
             tooltips: [],
             inputVariables: [],
             originalVariables: [],
             userdata: session ? JSON.parse(session).userdata.details : null,
         };
         this.renderEditable = this.renderEditable.bind(this);
         this.renderEditableTreatments = this.renderEditableTreatments.bind(this);
         this.handleEdit = this.handleEdit.bind(this);
     }
 
     componentDidMount() {
         this.getAllVariableGroups();
     }
 
     getAllVariableGroups() {
         // ensure all variable groups are loaded and cached in Config
         if (!Config.variableGroups) {
             new modelInputService().getAllVariableGroups().then((groups) => {
                 Config.variableGroups = groups;
                 // refresh this component
                 this.setState({});
             });
         }
     }
 
     /**
      * Rendering editable ell
      * @param {object} cellInfo current cell info
      */
     renderEditable(cellInfo) {
         const { inputVariables, originalVariables } = this.state;
         let cellValue = inputVariables[cellInfo.index][cellInfo.column.id];
         if (cellValue) {
             cellValue = JSON.parse(JSON.stringify(cellValue));
         }
         let modified = false;
         let className = 'td-value';
         let title = '';
         if (originalVariables[cellInfo.index]) {
             const origCellValue = originalVariables[cellInfo.index][cellInfo.column.id];
             modified = origCellValue !== undefined && +origCellValue !== +cellValue;
             if (modified) {
                 className = 'td-edited';
                 title = 'original: ' + origCellValue;
             }
         }
 
         /**
          * Editable cell rendering for react table
          */
         return (
             <div
                 style={{}}
                 contentEditable
                 suppressContentEditableWarning
                 onBlur={(e) => {
                     const newCellValue = Number(e.target.innerText);
                     if (isNaN(newCellValue)) {
                         return;
                     }
                     if (cellValue !== newCellValue) {
                        this.props.setVariablesUpdated(true, this.props.variableGroup);
                    }
                     if (!originalVariables[cellInfo.index]) {
                         originalVariables[cellInfo.index] = [];
                     }
                     if (originalVariables[cellInfo.index][cellInfo.column.id] === undefined) {
                         originalVariables[cellInfo.index][cellInfo.column.id] = cellValue;
                     }
                     inputVariables[cellInfo.index][cellInfo.column.id] = newCellValue;
 
                     ModelHelper.recalcComputedVariables(inputVariables, cellInfo.index, cellInfo.column.id);
 
                     this.setState({ inputVariables, originalVariables });
                     this.handleEdit(inputVariables);
                 }}
                 title={title}
                 className={className}
                 onFocus={this.selectInput}
                 onClick={this.selectInput}
                 onKeyPress={this.changeNumber}
                 onPaste={this.blockCopyPasteCharacters}
             >
                 {cellValue}
             </div>
         );
     }
 
      /**
      * Rendering editable ell
      * @param {object} cellInfo current cell info
      */
       renderEditableTreatments(cellInfo) {
         const { inputVariables, originalVariables } = this.state;
         let cellValue = inputVariables[cellInfo.index][cellInfo.column.id];
         if (cellValue) {
             cellValue = JSON.parse(JSON.stringify(cellValue));
         }
         let modified = false;
         let className = 'td-value';
         let title = '';
         if (originalVariables[cellInfo.index]) {
             const origCellValue = originalVariables[cellInfo.index][cellInfo.column.id];
             modified = origCellValue !== undefined && +origCellValue !== +cellValue;
             if (modified) {
                 className = 'td-edited';
                 title = 'original: ' + origCellValue;
             }
         }
 
         /**
          * Editable cell rendering for react table
          */
         return (
             <div
                 style={{}}
                 contentEditable
                 suppressContentEditableWarning
                 onBlur={(e) => {
                     const newCellValue = Number(e.target.innerText);
                     if (isNaN(newCellValue)) {
                         return;
                     }
                     if (cellValue !== newCellValue) {
                         this.props.setVariablesUpdated(true, this.props.variableGroup);
                     }
                     if (!originalVariables[cellInfo.index]) {
                         originalVariables[cellInfo.index] = [];
                     }
                     if (originalVariables[cellInfo.index][cellInfo.column.id] === undefined) {
                         originalVariables[cellInfo.index][cellInfo.column.id] = cellValue;
                     }
                     inputVariables[cellInfo.index][cellInfo.column.id] = newCellValue;
 
                     ModelHelper.recalcComputedVariables(inputVariables, cellInfo.index, cellInfo.column.id);
 
                     this.setState({ inputVariables, originalVariables });
                     this.handleEdit(inputVariables);
                 }}
                 title={title}
                 className={className}
                 onFocus={this.selectInput}
                 onClick={this.selectInput}
                 onKeyPress={this.changeNumberTreatment}
                 onKeyUp={this.changeNumberUp}
                 onPaste={this.blockCopyPasteCharacters}
             >
                 {cellValue}
             </div>
         );
     }
 
     /**
      * Select input on click or focus
      * @param {*} event event
      */
     selectInput = (event) => {
         if (document.selection) {
             let range = document.body.createTextRange();
             range.moveToElementText(event.target);
             range.select();
         } else if (window.getSelection) {
             let ranges = document.createRange();
             ranges.selectNodeContents(event.target);
             window.getSelection().removeAllRanges();
             window.getSelection().addRange(ranges);
         }
     };
 
     /**
      * Block the characters other than numbers on key press.
      */
     changeNumber = (event) => {
         const charCode = event.which ? event.which : event.keyCode;
         if ((charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 13 ) {
             event.preventDefault();
         }
     };
 
      /**
      * Block the characters other than numbers on key press.
      */
       changeNumberTreatment = (event) => {
         const newCellValue =  Number(event.target.innerText);
         const charCode = event.which ? event.which : event.keyCode;
         if (event.target.innerText.length > 2 || newCellValue > 12 ) {
             event.target.innerText = 12;
             event.preventDefault();
         }
         if ((charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 13 ) {
             event.preventDefault();
         }
     };
 
     /**
      * Block the characters other than numbers on key press.
      */
      changeNumberUp = (event) => {
         console.log(' Number(e.target.innerText)',  Number(event.target.innerText))
         const newCellValue =  Number(event.target.innerText);
         if (isNaN(newCellValue)) {
             event.preventDefault();
         }
         if (event.target.innerText.length > 2 || newCellValue > 12 ) {
             event.target.innerText = 12;
             event.preventDefault();
         }
 
     };
 
     /**
      * Block the characters other than numbers on copy paste.
      */
     blockCopyPasteCharacters = (window) => {
         if (window && window.clipboardData.getData('Text').match(/[^0-9.]/)) {
             window.preventDefault();
         }
     };
 
     /**
      * Update the values to api
      */
     handleEdit = (inputVariables) => {
         console.log("inputVariables", inputVariables);
         this.props.updateState(inputVariables);
     };
 
     /**
      * Props change auto invoke function
      */
     static getDerivedStateFromProps(props) {
         if (props.getInitialModels && props.getInitialModels.initial) {
             return {
                 inputVariables: props.getInitialModels.initial.variables,
                 tooltips: props.getInitialModels.initial.variableTooltips,
             };
         }
         return null;
     }
 
     /**
      * Render dom elements
      */
     render() {
         let { inputVariables, originalVariables } = this.state;
 
         if (this.props.flags && this.props.flags.resetOriginalValuesFlag) {
             originalVariables.length = 0;
         }
 
         ModelHelper.initializeComputedVariables(inputVariables);
 
         /**
          * Rendering react table
          */
         const renderTableView = () => {
             const columns = [
                 {
                     Header: () => <div style={{ textAlign: 'left' }}>Category</div>,
                     accessor: 'categoryName',
                     className: 'category',
                 },
             ];
 
             const vg = R.path(['variableGroups', this.props.variableGroup], Config);
 
             if (!vg) {
                 return <div>*** ERROR getting VariableGroups ***</div>;
             }
 
             for (let i in vg.variables) {
                 const v = vg.variables[i];
                 let col;
                 if(vg.variableGroup === 'Patient & RX' && v.variableKey === 'treatments'){
                     console.log("v", v);
                     col = {
                         Header: <div style={{ textAlign: 'center' }}>{v.variableDescription}</div>,
                         accessor: v.variableKey,
                         Cell: this.renderEditableTreatments,
                         className: 'td-values',
                     };
                 }else{
                     col = {
                         Header: <div style={{ textAlign: 'center' }}>{v.variableDescription}</div>,
                         accessor: v.variableKey,
                         Cell: this.renderEditable,
                         className: 'td-values',
                     };
                 }
                 
 
                 columns.push(col);
                 ModelHelper.renderComputedVariables(v, columns);
             }
             return (
                 <ReactTable
                     className="-striped -highlight"
                     data={inputVariables}
                     columns={columns}
                     sortable={true}
                     showPagination={false}
                     showPageSizeOptions={false}
                     pageSize={inputVariables.length ? inputVariables.length : 1}
                 />
             );
         };
         return <div>{renderTableView()}</div>;
     }
 }
 
 /**
  * Mapping redux state into props
  */
 const MapStateToProps = (state) => {
     return {
         getInitialModels: state.getInitialAction,
         modelDetails: state.modelChangeAction,
         flags: state.resetOriginalValuesFlag,
     };
 };
 
 /**
  * Dispatching redux actions
  */
 const MapDispatchToProps = (dispatch) => {
     return {
         updateState: (revParams) => dispatch(inputVariablesAction(revParams)),
         setVariablesUpdated: (status, group) =>
             dispatch(
                 isParametersOrVariablesUpdatedAction({
                     status: status,
                     group: group,
                 }),
             ),
     };
 };
 
 BaseVariables.propTypes = {
     updateState: PropTypes.func,
     modelDetails: PropTypes.object,
     variableGroup: PropTypes.string,
     setVariablesUpdated: PropTypes.func,
     getInitialModels: PropTypes.object,
     expandTable: PropTypes.bool,
     flags: PropTypes.object,
 };
 
 export default connect(MapStateToProps, MapDispatchToProps)(BaseVariables);
 